import Pool from "@/firebase/championnat/pool.js"
import Equipe from "./equipe";
export default class Tirage {
    options = null;
    nbJoueurs = 0;
    pools = [];
    eliminatoire=[];
    constructor (options) {
        this.options = options;
        this.nbJoueurs = options.nbJoueurs;
    }
    findNbEquipeIdeal(nb) {
        if (typeof(nb)=="undefined") 
            var nbEquipeSortant = this.pools.length * 2;
        else
            var nbEquipeSortant = nb;
      
        var nbEquipe = 0;
        if (nbEquipeSortant <= 4 && nbEquipeSortant >= 2) {
            nbEquipe = nbEquipeSortant - 2;
        }
        if (nbEquipeSortant <= 8 && nbEquipeSortant >= 4) {
            nbEquipe =  nbEquipeSortant - 4;
        }
        if (nbEquipeSortant <= 16 && nbEquipeSortant >= 8) {
            nbEquipe =  nbEquipeSortant - 8;
        }
        if (nbEquipeSortant <= 32 && nbEquipeSortant >= 16) {
            nbEquipe =  nbEquipeSortant - 16;
        }
        if (nbEquipeSortant <= 64 && nbEquipeSortant >= 32) {
            nbEquipe =  nbEquipeSortant - 32;
        }
        if (nbEquipeSortant <= 128 && nbEquipeSortant >= 64) {
            nbEquipe =  nbEquipeSortant - 64;
        }
        if (nbEquipeSortant <= 256 && nbEquipeSortant >= 128) {
            nbEquipe =  nbEquipeSorant - 128;
        }
        if (nbEquipeSortant <= 512 && nbEquipeSortant >= 256) {
            nbEquipe =  nbEquipeSortant - 256;
        }
        
        return nbEquipe;
    }
    howNbPools(nb) {
        if (typeof(nb)=="undefined") 
            var nbEquipeSorant = this.pools.length * 2;
        else
            var nbEquipeSorant = nb;
        var nbEquipe = 0;
        var nbEquipeCible=0;
        if (nbEquipeSorant <= 4) {
            nbEquipeCible = 4;
            nbEquipe = 4 - nbEquipeSorant;
        }
        else if (nbEquipeSorant <= 8) {
            nbEquipeCible = 8;
            nbEquipe =  8 - nbEquipeSorant;
        }
        else if (nbEquipeSorant <= 16) {
            nbEquipeCible = 16;
            nbEquipe =  16 - nbEquipeSorant;
        }
        else if (nbEquipeSorant <= 32) {
            nbEquipeCible = 32;
            nbEquipe = 32 - nbEquipeSorant;
        }
        else if (nbEquipeSorant < 64) {
            nbEquipeCible = 64;
            nbEquipe = 64 - nbEquipeSorant;
        }
        else if (nbEquipeSorant <= 128) {
            nbEquipeCible = 128;
            nbEquipe = 128 - nbEquipeSorant;
        }
        else if (nbEquipeSorant <= 256) {
            nbEquipeCible = 256;
            nbEquipe = 256 - nbEquipeSorant;
        }
        else if (nbEquipeSorant <= 512) {
            nbEquipeCible = 512;
            nbEquipe = 512 - nbEquipeSorant;
        }
        var nbManquePool = Math.ceil(nbEquipe / 2);
        return {
            nbEquipeSorant: nbEquipeSorant,
            manqueNbEquipe: nbEquipe,
            manqueNbPool: nbManquePool,
            nbEquipeCible: nbEquipeCible,
            nbPool : this.pools.length
        }
    }
    addCadrage2 () {
        var findNB = this.findNbEquipeIdeal();
        var nbEquipesACompleter = findNB * 2;
        
        while (listTempoJoueurs.length>0 && nbEquipes < nbEquipesACompleter) {
            var newEquipe = new Equipe(this.options);
            nbEquipes++;
            //Equipe JOUEURS
            var indexJoueur = this.random(0,listTempoJoueurs.length);
            var numeroJoueur = listTempoJoueurs[indexJoueur];
            newEquipe.dataJoueurs.joueurs.J1 = parseInt(numeroJoueur);
            eliminatoire_data.joueurs.push(numeroJoueur);
            listTempoJoueurs.splice(indexJoueur, 1);
            //Equipe CONTRE
            indexJoueur = this.random(0,listTempoJoueurs.length);
            numeroJoueur = listTempoJoueurs[indexJoueur];
            newEquipe.dataJoueurs.contre.J1 = parseInt(numeroJoueur);
            eliminatoire_data.joueurs.push(numeroJoueur);
            listTempoJoueurs.splice(indexJoueur, 1);
            nbEquipes++;
            eliminatoire_data.equipes.push(newEquipe);
        }
    }
    addCadrage(JSON_qualifie) {
      
        if (this.eliminatoire.length>0) {
           
            var eliminatoire = this.eliminatoire[this.eliminatoire.length-1]
            var listJoueurs = eliminatoire.joueurs.slice();
            var nbJoueurASUP=0;
          
            listJoueurs.forEach(joueur=>{
                if (joueur == null)
                    nbJoueurASUP++;
            })
            listJoueurs.splice(listJoueurs.length-(nbJoueurASUP), nbJoueurASUP);
        
            var findNB = this.findNbEquipeIdeal(listJoueurs.length);
          
            var nbEquipesACompleter = findNB * 2;
            
         
            var listTempoJoueurs = listJoueurs.slice();
            var eliminatoire_data={
                equipes: [],
                joueurs: []
            }
            var nbEquipes = 0;
           
            while (listTempoJoueurs.length>0 && nbEquipes < nbEquipesACompleter) {
                var newEquipe = new Equipe(this.options);
                nbEquipes++;
                //Equipe JOUEURS
                var indexJoueur = this.random(0,listTempoJoueurs.length);
                var numeroJoueur = listTempoJoueurs[indexJoueur];
                newEquipe.dataJoueurs.joueurs.J1 = parseInt(numeroJoueur);
                eliminatoire_data.joueurs.push(numeroJoueur);
                listTempoJoueurs.splice(indexJoueur, 1);
                //Equipe CONTRE
                indexJoueur = this.random(0,listTempoJoueurs.length);
                numeroJoueur = listTempoJoueurs[indexJoueur];
                newEquipe.dataJoueurs.contre.J1 = parseInt(numeroJoueur);
                eliminatoire_data.joueurs.push(numeroJoueur);
                listTempoJoueurs.splice(indexJoueur, 1);
                nbEquipes++;
                eliminatoire_data.equipes.push(newEquipe);

            }
            this.eliminatoire.push(eliminatoire_data);
        }
        else {
            if (typeof(JSON_qualifie)!="undefined") {
                var tabWINNERS=[];
                JSON_qualifie.win1.forEach((win)=>{
                    tabWINNERS.push(win.numero);
                });
                JSON_qualifie.win2.forEach((win)=>{
                    tabWINNERS.push(win.numero);
                });
                var listTempoJoueurs = tabWINNERS.slice();

                var findNB = this.findNbEquipeIdeal(listTempoJoueurs.length);
          
                var nbEquipesACompleter = findNB * 2;

                var eliminatoire_data={
                    equipes: [],
                    joueurs: []
                }
                var nbEquipes = 0;
                
                
                while (listTempoJoueurs.length>0 && nbEquipes < nbEquipesACompleter) {
                    var newEquipe = new Equipe(this.options);
                    nbEquipes++;
                    //Equipe JOUEURS
                    var indexJoueur = this.random(0,listTempoJoueurs.length);
                    var numeroJoueur = listTempoJoueurs[indexJoueur];
                    newEquipe.dataJoueurs.joueurs.J1 = numeroJoueur;
                    eliminatoire_data.joueurs.push(numeroJoueur);
                    listTempoJoueurs.splice(indexJoueur, 1);
                    //Equipe CONTRE
                    indexJoueur = this.random(0,listTempoJoueurs.length);
                    numeroJoueur = listTempoJoueurs[indexJoueur];
                    newEquipe.dataJoueurs.contre.J1 = numeroJoueur;
                    eliminatoire_data.joueurs.push(numeroJoueur);
                    listTempoJoueurs.splice(indexJoueur, 1);
                    nbEquipes++;
                    eliminatoire_data.equipes.push(newEquipe);

                }
                this.eliminatoire.push(eliminatoire_data);
            }
            
        }

    }
    setEliminatoire(index) {
        
        if (index>0) {
            this.eliminatoire.splice(index, this.eliminatoire.length);
            var eliminatoirePrec = this.eliminatoire[index-1];
            var indexEquipe = 0;
            var equipes=[];
            var joueurs=[];
            while (indexEquipe<eliminatoirePrec.equipes.length) {
                if (eliminatoirePrec.equipes[indexEquipe].score["joueurs"] == null) {
                    var joueur1 = null;
                    joueurs.push(joueur1);
                }
                else if (eliminatoirePrec.equipes[indexEquipe].score["joueurs"] > eliminatoirePrec.equipes[indexEquipe].score["contre"]) {
                    var joueur1 = eliminatoirePrec.equipes[indexEquipe].dataJoueurs.joueurs.J1;
                    joueurs.push(joueur1);
                }
                else {
                    var joueur1 = eliminatoirePrec.equipes[indexEquipe].dataJoueurs.contre.J1;
                    joueurs.push(joueur1);
                }

                indexEquipe++;
                if (eliminatoirePrec.equipes.length>1) {
                    if (eliminatoirePrec.equipes[indexEquipe].score["joueurs"] == null) {
                        var joueur2 = null;
                        joueurs.push(joueur2);
                    }
                    else if (indexEquipe<eliminatoirePrec.equipes.length) {
                        if (eliminatoirePrec.equipes[indexEquipe].score["joueurs"] > eliminatoirePrec.equipes[indexEquipe].score["contre"]) {
                            var joueur2 = eliminatoirePrec.equipes[indexEquipe].dataJoueurs.joueurs.J1;
                            joueurs.push(joueur2);
                        }
                        else {
                            var joueur2 = eliminatoirePrec.equipes[indexEquipe].dataJoueurs.contre.J1;
                            joueurs.push(joueur2);
                        }
                    }
                    else
                        var joueur2 = null;
                    indexEquipe++;
                    var equipeObject = new Equipe(this.options);
                    equipeObject.dataJoueurs.joueurs.J1 = joueur1;
                    equipeObject.dataJoueurs.contre.J1 = joueur2;
                    if (joueur2==null && joueur1!=null && (this.nbJoueurs%4==0)) {
                        equipeObject.score["contre"] = 7;
                        equipeObject.score["joueurs"] = 13;
                        equipeObject.state="FINISH";
                    }
                    equipes.push(equipeObject);
                }
            }
            var eliminatoire_object = {
                equipes: equipes,
                joueurs: joueurs
            }
            this.eliminatoire.push(eliminatoire_object);
        }
    }
    reinitEliminatoire(json_Elimininatoire) {
        json_Elimininatoire.forEach(eliminatoireItem=>{
            var json_elimniratoire_data = {
                equipes: [],
                joueurs: []   
            }
            eliminatoireItem.equipes.forEach(equipe=>{
                var equipeObject = new Equipe(this.options);
                equipeObject.dataJoueurs.joueurs.J1 = equipe.joueurs.J1.numero;
                equipeObject.dataJoueurs.contre.J1 = equipe.contre.J1.numero;
                equipeObject.score = JSON.parse(JSON.stringify(equipe.score));
                equipeObject.state = JSON.parse(JSON.stringify(equipe.state));
                json_elimniratoire_data.joueurs.push(equipe.joueurs.J1.numero);
                json_elimniratoire_data.joueurs.push(equipe.contre.J1.numero);
                json_elimniratoire_data.equipes.push(equipeObject);
            })
            this.eliminatoire.push(json_elimniratoire_data);
        })
    }
    getJsonEliminatoire() {
        var json_elimniratoire = []
        this.eliminatoire.forEach(eliminatoireItem=>{
            var json_elimniratoire_data = {
                equipes: []
            }
            eliminatoireItem.equipes.forEach(equipe=>{
                json_elimniratoire_data.equipes.push(equipe.getJson());
            })
            json_elimniratoire.push(json_elimniratoire_data);
        })
        return json_elimniratoire;
    }
    random(min, max) {
        return Math.floor(min + Math.random() * (max - min));
    }
    findIndexPool(numero) {
        var find;
        this.pools.forEach((pool, indexPool)=>{
            if (pool.joueurs.indexOf(numero) != -1)
                find = indexPool;
        })
        return find;
    }
    traiterErrorElimnatoire() {
        if (this.eliminatoire.length>0) {
            var newEquipes=[];
            var eliminatoire = this.eliminatoire[0];
            if (this.eliminatoire[0].equipes.length>1) {
                eliminatoire.equipes.forEach((equipe, indexEquipe)=>{
                    if (equipe.dataJoueurs.joueurs.J1 != null && equipe.dataJoueurs.contre.J1) {
                        var indexPoolJoueur = this.findIndexPool(equipe.dataJoueurs.joueurs.J1);
                        var indexPoolContre = this.findIndexPool(equipe.dataJoueurs.contre.J1);
                        if (indexPoolContre == indexPoolJoueur) { // Il faut changer ils étaient dans la même POOL !
                            var find = false;
                            eliminatoire.equipes.forEach((equipeFind, indexEquipeFind)=> {
                                if (indexEquipeFind != indexEquipe && !find) {
                                    var numeroTempo = equipeFind.dataJoueurs.contre.J1;
                                    equipeFind.dataJoueurs.contre.J1 = equipe.dataJoueurs.contre.J1;
                                    equipe.dataJoueurs.contre.J1 = numeroTempo;
                                    find = true;
                                }
                            });
                            if (!find) {
                                var newEquipe = new Equipe(this.options);
                                newEquipe.dataJoueurs.contre.J1 =  equipe.dataJoueurs.contre.J1;
                                equipe.dataJoueurs.contre.J1 = null;
                                newEquipes.push(newEquipe);
                            }
                        }
                    }

                })
                newEquipes.forEach(equipeNew=>{
                    eliminatoire.equipes.push(equipeNew);
                })
            }
        }
    }
    initEliminatoire(JSON_qualifie, repechage) {
        if (this.eliminatoire.length==0) {
            this.eliminatoire[0] = {
                equipes: [],
                joueurs: []
            }
        }
        if (!repechage) {
            var nbEliminatoire = this.pools.length;
            
            if (this.eliminatoire[0].equipes.length==0) {
                for (var indexEquipe=0;indexEquipe<nbEliminatoire;indexEquipe++) {
                    var equipe = new Equipe(this.options);
                    this.eliminatoire[0].equipes.push(equipe);
                }
            }
        }
       
        var tabWIN2=[];
        JSON_qualifie.win2.forEach((win, indexWin)=>{
            tabWIN2.push(indexWin);
        })
       
        while (tabWIN2.length>0) {
            var indexWin = this.random(0, tabWIN2.length);
            var win = JSON.parse(JSON.stringify(JSON_qualifie.win2[tabWIN2[indexWin]]));
            if (this.eliminatoire[0].joueurs.indexOf(win.numero)==-1) {
                var indexEquipe = 0;
                var equipesTempo = [];
                this.eliminatoire[0].equipes.forEach((equipeT,indexEquipeT)=>{
                    equipesTempo.push(indexEquipeT);
                });
               
                var find = false;
                while (equipesTempo.length>0 && !find) {
                   
                    if (equipesTempo.length==1)
                        var indexEquipeT = 0;
                    else
                        var indexEquipeT = this.random(0, equipesTempo.length);
                  
                    indexEquipe = equipesTempo[indexEquipeT];
                    if (this.eliminatoire[0].equipes[indexEquipe].dataJoueurs.joueurs.J1 == null) {
                        this.eliminatoire[0].equipes[indexEquipe].dataJoueurs.joueurs.J1 = win.numero;
                        this.eliminatoire[0].joueurs.push(win.numero);
                        find = true;
                   
                    }
                    else {
                        equipesTempo.splice(indexEquipeT, 1);
                        indexEquipe++;
                    }
                }
            }
            tabWIN2.splice(indexWin, 1);
        }
       
        var tabWIN1=[];
        JSON_qualifie.win1.forEach((win, indexWin)=>{
            tabWIN1.push(indexWin);
        })
        
        
        
        this.eliminatoire[0].equipes.forEach(equipe=>{
            if (tabWIN1.length>0) {
                var indexWin = this.random(0, tabWIN1.length);
                var win = JSON.parse(JSON.stringify(JSON_qualifie.win1[tabWIN1[indexWin]]));
                equipe.dataJoueurs.contre.J1 = win.numero;
                tabWIN1.splice(indexWin, 1);
            }
        })
        
        this.traiterErrorElimnatoire();
        
    }
    
    qualifie() {
        var historiqueResultatJoueurs={};
        this.pools.forEach((pool, indexPool)=>{
            pool.parties.forEach((partie, indexPartie)=>{
                partie.equipes.forEach((equipe, indexEquipe)=>{
                    if (equipe.score["joueurs"]!=null) {
                        if (typeof(historiqueResultatJoueurs[equipe.dataJoueurs.joueurs.J1])=="undefined") {
                            historiqueResultatJoueurs[equipe.dataJoueurs.joueurs.J1] = {
                                nbGagnes: 0,
                                goalAverage: 0,
                                barage: false,
                                pool: indexPool,
                                nbParties: indexPartie
                            }
                        }
                        if (typeof(historiqueResultatJoueurs[equipe.dataJoueurs.contre.J1])=="undefined") {
                            historiqueResultatJoueurs[equipe.dataJoueurs.contre.J1] = {
                                nbGagnes: 0,
                                goalAverage: 0,
                                barage: false,
                                pool: indexPool,
                                nbParties: indexPartie
                            }
                        }
                        historiqueResultatJoueurs[equipe.dataJoueurs.joueurs.J1].nbParties++;
                        historiqueResultatJoueurs[equipe.dataJoueurs.contre.J1].nbParties++;
                        if (equipe.score["joueurs"]>equipe.score["contre"]) {
                            historiqueResultatJoueurs[equipe.dataJoueurs.joueurs.J1].nbGagnes++;
                            
                            historiqueResultatJoueurs[equipe.dataJoueurs.joueurs.J1].goalAverage += equipe.score["joueurs"] - equipe.score["contre"];
                            historiqueResultatJoueurs[equipe.dataJoueurs.contre.J1].barage = true;
                            historiqueResultatJoueurs[equipe.dataJoueurs.contre.J1].goalAverage += equipe.score["contre"] - equipe.score["joueurs"];
                        }
                        else  {
                            historiqueResultatJoueurs[equipe.dataJoueurs.contre.J1].nbGagnes++;
                            historiqueResultatJoueurs[equipe.dataJoueurs.contre.J1].goalAverage += equipe.score["contre"] - equipe.score["joueurs"];
                            historiqueResultatJoueurs[equipe.dataJoueurs.joueurs.J1].barage = true;
                            historiqueResultatJoueurs[equipe.dataJoueurs.joueurs.J1].goalAverage += equipe.score["joueurs"] - equipe.score["contre"];
                            
                        }
                    }
                    
                    
                
                })
            })
        })
        var JSON_qualifie = {
            win1: [],
            win2: [],
            looser: [],
            bigLooser: []
        }
        var elt = {
            numero: null,
            goalAverage: null,
            pool: null
        }
        
        for (var key in historiqueResultatJoueurs) {
          
            var elt = {
                numero: null,
                goalAverage: null,
                pool: historiqueResultatJoueurs[key].pool
            }
            elt.numero = key;
            elt.goalAverage = historiqueResultatJoueurs[key].goalAverage;
            if (historiqueResultatJoueurs[key].nbGagnes == 3) 
                JSON_qualifie.win2.push(elt);
            else if (historiqueResultatJoueurs[key].nbGagnes == 2) 
                JSON_qualifie.win1.push(elt)
            else if (historiqueResultatJoueurs[key].nbGagnes == 0 && historiqueResultatJoueurs[key].nbParties==2) {
                JSON_qualifie.bigLooser.push(elt);
            }
            else if (historiqueResultatJoueurs[key].nbParties==3) {
                 if (historiqueResultatJoueurs[key].nbGagnes == 1) {
                    JSON_qualifie.looser.push(elt)
                }
                else {
                    JSON_qualifie.bigLooser.push(elt);
                }
            }
        }
        return JSON_qualifie;
    }
    reinitPool(poolJson) {
        poolJson.forEach((pool, indexPool)=>{
            this.pools[indexPool] = new Pool(this.options, indexPool);
            this.pools[indexPool].joueurs = pool.joueurs.slice();
            pool.parties.forEach((partie, indexPartie)=>{
                this.pools[indexPool].parties[indexPartie] = {
                    equipes: []
                }
                partie.equipes.forEach((equipe, indexEquipe)=>{
                    var equipeObject = new Equipe(this.options, indexPool);
                    equipeObject.dataJoueurs.joueurs.J1 = equipe.joueurs.J1.numero;
                    equipeObject.dataJoueurs.contre.J1 = equipe.contre.J1.numero;
                    equipeObject.score = JSON.parse(JSON.stringify(equipe.score));
                    equipeObject.state = JSON.parse(JSON.stringify(equipe.state));
                    this.pools[indexPool].parties[indexPartie].equipes[indexEquipe] = equipeObject;
                })
            })
            this.pools[indexPool].initHisto();
        })
        
    }
    initPools(nbPoolsParam) {

        var nbPools = this.nbJoueurs / this.options.nbJoueursParPool;
        
        if (typeof(nbPoolsParam)!="undefined") {
            if (nbPoolsParam>nbPools) {
                nbPools = nbPoolsParam
            }
        }
        
        
        var listNumeroJoueurs=[];
        for (var indexJoueur=0;indexJoueur<this.nbJoueurs;indexJoueur++) {
            listNumeroJoueurs.push(indexJoueur);
        }
       
        var indexPool;
        var bool = false;
        for (indexPool=0;indexPool<nbPools;indexPool++) {
            this.pools[indexPool] = new Pool (this.options, indexPool);
            this.pools[indexPool].initJoueurs(listNumeroJoueurs);
        }
      
        indexPool--;
        bool = (this.pools[indexPool].joueurs.length < this.options.nbMinJoueursParPool);
        // Là je remet les joueurs pour qu'il y a un minimum de 3 dans chaque POOL;
        while (bool) {
            if (this.pools[indexPool].joueurs.length < this.options.nbMinJoueursParPool) {
                var indexPoolSearch = this.searchIndexPoolASup(this.pools, indexPool-1);
                var indexJoueurASup =  this.pools[indexPoolSearch].joueurs.length-1;
                var numeroJoueur = this.pools[indexPoolSearch].joueurs[indexJoueurASup];
                this.pools[indexPool].joueurs.push(numeroJoueur);
                this.pools[indexPoolSearch].joueurs.splice(indexJoueurASup, 1);
            }
            else {
                indexPool--;
                if (indexPool<0)
                    bool = false;
            }
        }
    }
    init_TOUR2() {
       
        this.pools.forEach(pool=>{
            pool.init_TOUR2();
        })
    }
    init_BARAGE() {
        this.pools.forEach(pool=>{
            pool.init_BARRAGE();
        })
    }
    init() {
        this.pools.forEach(pool=>{
            pool.init();
        })
    }
    searchIndexPoolASup (pools, indexPool) {
        if (pools[indexPool].joueurs.length<=this.options.nbMinJoueursParPool)
            return this.searchIndexPoolASup(pools, indexPool-1);
        else
            return indexPool;
    }
    static initSimpleEliminatoire(JSON_qualifie) {
        var listJoueurs = JSON_qualifie.splice();
        var equipes = [];
        var max, min=0;
        JSON_qualifie.forEach(numero=>{
            listJoueurs.push(numero);
        })
        
        while (listJoueurs.length>0) {
            var newEquipe = new Equipe(this.options);
            max = listJoueurs.length;
            var indexJoueur = Math.floor(min + Math.random() * (max - min)); 
          
            newEquipe.dataJoueurs.joueurs.J1 = listJoueurs[indexJoueur];
            listJoueurs.splice(indexJoueur, 1);
            if (listJoueurs.length>0) {
                max = listJoueurs.length;
                indexJoueur = Math.floor(min + Math.random() * (max - min)); 
                newEquipe.dataJoueurs.contre.J1 = listJoueurs[indexJoueur];
                listJoueurs.splice(indexJoueur, 1);                
            }
            equipes.push(newEquipe.getJson());
        }
        return equipes;
    }
    getJson() {
        var poolJson = [];
        this.pools.forEach(pool=>{
            poolJson.push( pool.getJson())
        })
        return poolJson;
    }
}



